interface BuildInfo {
  readonly version: string;
  readonly commit: string | null;
}

// Replaced at build time. Direct ng serve/test runs remain explicitly local.
declare const MARESIAS_BUILD_INFO: BuildInfo;

export const BUILD_INFO: BuildInfo = typeof MARESIAS_BUILD_INFO === 'undefined'
  ? { version: 'local', commit: null }
  : MARESIAS_BUILD_INFO;
